import {
  registerDecorator,
  type ValidationArguments,
  type ValidationOptions,
} from 'class-validator';
import {
  isAcceptedMemberStateCode,
  isWellFormedApprovalNumber,
} from '../label/prepackaged-identification-mark';

/**
 * Validates the country code stamped in the oval health-mark (all. II sez. I
 * parte B punto 6 Reg. CE 853/2004): one of the EU member state codes.
 * Delegates to `isAcceptedMemberStateCode`, the same check the prepackaged
 * label module uses, so the accepted-codes list is defined in one place.
 */
export function IsIdentificationMarkCountryCode(validationOptions?: ValidationOptions) {
  return (object: object, propertyName: string) => {
    registerDecorator({
      name: 'isIdentificationMarkCountryCode',
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown, _args: ValidationArguments) {
          return typeof value === 'string' && isAcceptedMemberStateCode(value);
        },
        defaultMessage() {
          return 'Codice paese non valido';
        },
      },
    });
  };
}

/**
 * Validates the establishment approval number printed inside the oval mark
 * (art. 4 Reg. CE 853/2004), e.g. "1234". Delegates to
 * `isWellFormedApprovalNumber` — deliberately weak, see that function's
 * comment: the format varies by member state.
 */
export function IsIdentificationMarkApprovalNumber(validationOptions?: ValidationOptions) {
  return (object: object, propertyName: string) => {
    registerDecorator({
      name: 'isIdentificationMarkApprovalNumber',
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown, _args: ValidationArguments) {
          return typeof value === 'string' && isWellFormedApprovalNumber(value);
        },
        defaultMessage() {
          return 'Numero di riconoscimento non valido';
        },
      },
    });
  };
}
